// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary {
  --border-radius: var(--spacing-half);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: var(--spacing) var(--spacing) 0;
}
.summary__title {
  margin-top: 0;
  padding-top: 0;
  margin-bottom: var(--spacing-half);
}
.summary .orders {
  display: flex;
  flex-direction: column;
  gap: var(--spacing);
}
.summary .orders .order {
  border: 1px solid var(--ion-background-secondary-color);
  border-radius: var(--border-radius);
  padding: var(--spacing) var(--spacing) var(--spacing-half) var(--spacing);
}
.summary .orders .order h3 {
  margin-top: 0;
}
.summary .orders .order__tour .info {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.summary .orders .order__tickets {
  --border-radius: var(--spacing-quarter);
  padding-top: var(--spacing-half);
}
.summary .orders .order__tickets .tickets {
  display: grid;
  gap: var(--spacing-half);
  grid-template-columns: 1fr 1fr;
}
.summary .actions {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-half);
  padding-bottom: var(--spacing);
}
.summary .cancel-form {
  padding: var(--spacing) 0 0 var(--spacing);
  display: grid;
  gap: var(--spacing);
  margin: var(--spacing) 0 0 0;
  grid-template-columns: 1fr 1fr;
}
.summary .cancel-form .confirm-checkbox {
  display: flex;
  align-items: center;
  gap: var(--spacing);
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/order-summary/order-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,wCAAA;AAAJ;AAEI;EACI,aAAA;EACA,cAAA;EACA,kCAAA;AAAR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AADR;AAIQ;EACI,uDAAA;EACA,mCAAA;EACA,yEAAA;AAFZ;AAIY;EACI,aAAA;AAFhB;AAMgB;EACI,aAAA;EACA,8BAAA;AAJpB;AAUY;EACI,uCAAA;EACA,gCAAA;AARhB;AAUgB;EACI,aAAA;EACA,wBAAA;EACA,8BAAA;AARpB;AAcI;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,8BAAA;AAZR;AAeI;EACI,0CAAA;EAEA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,8BAAA;AAdR;AAgBQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAdZ","sourcesContent":[".summary {\n    --border-radius: var(--spacing-half);\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n    padding: var(--spacing) var(--spacing) 0;\n\n    &__title {\n        margin-top: 0;\n        padding-top: 0;\n        margin-bottom: var(--spacing-half);\n    }\n\n    .orders {\n        display: flex;\n        flex-direction: column;\n        gap: var(--spacing);\n\n\n        .order {\n            border: 1px solid var(--ion-background-secondary-color);\n            border-radius: var(--border-radius);\n            padding: var(--spacing) var(--spacing) var(--spacing-half) var(--spacing);\n\n            h3 {\n                margin-top: 0;\n            }\n\n            &__tour {\n                .info {\n                    display: grid;\n                    grid-template-columns: 1fr 1fr;\n                }\n\n                .owner {}\n            }\n\n            &__tickets {\n                --border-radius: var(--spacing-quarter);\n                padding-top: var(--spacing-half);\n\n                .tickets {\n                    display: grid;\n                    gap: var(--spacing-half);\n                    grid-template-columns: 1fr 1fr;\n                }\n            }\n        }\n    }\n\n    .actions {\n        display: flex;\n        flex-direction: column;\n        gap: var(--spacing-half);\n        padding-bottom: var(--spacing);\n    }\n\n    .cancel-form {\n        padding: var(--spacing) 0 0 var(--spacing);\n        //background-color: var(--ion-background-secondary-color);\n        display: grid;\n        gap: var(--spacing);\n        margin: var(--spacing) 0 0 0;\n        grid-template-columns: 1fr 1fr;\n\n        .confirm-checkbox {\n            display: flex;\n            align-items: center;\n            gap: var(--spacing);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
